import { APP_COUNTRY, ONETRUST_ID } from '../../config';

export function loadOneTrustScripts() {
  if (!ONETRUST_ID) return;

  // Load OtAutoBlock.js
  const autoBlockScript = document.createElement('script');
  autoBlockScript.type = 'text/javascript';
  autoBlockScript.src = `https://cdn.cookielaw.org/consent/${ONETRUST_ID}/OtAutoBlock.js`;
  document.body.appendChild(autoBlockScript);

  // Load otSDKStub.js
  const sdkStubScript = document.createElement('script');
  sdkStubScript.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
  sdkStubScript.type = 'text/javascript';
  sdkStubScript.charset = 'UTF-8';
  sdkStubScript.setAttribute('data-domain-script', ONETRUST_ID);
  const dataLanguage = getOneTrustDataLanguageCode();
  if (dataLanguage) {
    sdkStubScript.setAttribute('data-language', dataLanguage);
  }
  document.body.appendChild(sdkStubScript);

  // Define OptanonWrapper function
  window.OptanonWrapper = function () {};
}

function getOneTrustDataLanguageCode() {
  switch (APP_COUNTRY) {
    case 'es':
      return 'es';
    case 'fr':
      return 'fr';
    case 'pt':
      return 'pt';
  }
}
